import { SgvJson } from "@financial/arch";


export class ApportionmentAnalysisChartOfAccount {

    constructor(
        public readonly type: string = '',
        public readonly name: string = '',
        public readonly classification: string = '',
        public readonly apportionment: string = ""
    ) { }

    get classificationAndName(): string {
        return `${this.classification} - ${this.name}`;
    }

    toJson() {
        return SgvJson.to.simple(this);
    }

    static fromJson(json: any) {
        return json ? SgvJson.from.simple(json, ApportionmentAnalysisChartOfAccount) : null;
    }

}
